import styles from './RoomScene.module.css'

export default function RoomScene({ specifier, thumbnailSize, onSelect, isActive }) {
    return (
        <li className={`${styles.roomscene} ${isActive ? styles.active : ''}`}
            styles={''}
            onClick={() => { onSelect(specifier) }} >
            <img
                src={`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?spec=${specifier}&type=base&size=${thumbnailSize}`}
                loading="lazy" 
                alt={`Roomscene : ${specifier}`} />
        </li>
    );
}